import { render, staticRenderFns } from "./ServerErrorModal.vue?vue&type=template&id=1afb2de6"
import script from "./ServerErrorModal.vue?vue&type=script&lang=ts"
export * from "./ServerErrorModal.vue?vue&type=script&lang=ts"
import style0 from "./ServerErrorModal.vue?vue&type=style&index=0&id=1afb2de6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports